import * as React from "react";
import styled, { css } from "styled-components";

import Select from "@8x8/oxygen-select";

import { PositionedLabel } from "@/react/features/styled/PositionedLabel";

export const PLACEHOLDER_SELECTED_VALUE = null;

const SelectContainer = styled.div`
  flex: 1;
  ${(props) =>
    props?.orientation === "inline" &&
    css`
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      gap: 8px;
    `}
`;

const SetWidthSelect = styled(Select)`
  width: ${(props) =>
    props?.selectWidth ? `${props.selectWidth}px` : "unset"};
`;

const LabeledSelect = (props) => {
  const {
    value,
    populateOnMount = false,
    prompt,
    placeholder,
    hasError,
    options,
    isClearable,
    htmlId,
    onSelectionChanged,
    onOptionCreatedRequest,
    isDisabled,
    orientation,
    ...other
  } = props;

  const [selectedOption, setSelectedOption] = React.useState(null);
  const [input, setInput] = React.useState("");

  const handleSelectionChanged = (selection) => {
    setSelectedOption(selection);
    onSelectionChanged &&
      onSelectionChanged(
        selection
          ? selection.value ?? selection.label
          : PLACEHOLDER_SELECTED_VALUE
      );
  };

  React.useEffect(() => {
    if (value && populateOnMount) {
      handleSelectionChanged(value);
    }
  }, []);

  const onKeyDownEvent = (event) => {
    // Nothing to do if no value is currently entered
    if (!input || input === "") {
      return;
    }

    // If the key is any sort of tab or newline type character, commit the entered value
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault();
      onOptionCreatedRequest && onOptionCreatedRequest(input);
      setInput("");
    }
  };

  return (
    <SelectContainer orientation={orientation}>
      <PositionedLabel isDisabled={isDisabled}>{prompt}</PositionedLabel>
      <SetWidthSelect
        {...other}
        isDisabled={isDisabled}
        placeholder={placeholder}
        hasError={hasError ?? false}
        isClearable={isClearable ?? false}
        value={selectedOption}
        onChange={handleSelectionChanged}
        options={options}
        testId={htmlId}
        id={htmlId}
        inputValue={input}
        onInputChange={(inputValue) => setInput(inputValue)}
        onKeyDown={onKeyDownEvent}
      />
    </SelectContainer>
  );
};

export default LabeledSelect;
